import React from 'react'
import { Container, Header, Dimmer, Loader, Divider } from 'semantic-ui-react'
import ReactChartkick, { LineChart, BarChart, PieChart, AreaChart } from 'react-chartkick'
import Chart from 'chart.js'

ReactChartkick.addAdapter(Chart)

class Dashboard extends React.Component {
  constructor (state) {
    super(state);
    this.state    = []
    this.getStats = this.getStats.bind(this)
  }

  componentDidMount () {
    this.getStats()
  }

  fetch (endpoint) {
    return window.fetch(endpoint)
      .then(response => response.json())
      .catch(error => console.log(error))
  }

  getStats () {
    this.fetch("https://api.liftsearch.co.za/dashboard")
      .then(stats => {
        if (stats.length) {
          this.setState({stats: stats})
        } else {
          this.setState({stats: []})
        }
      })
  }

  render () {
    let stats = this.state.stats
    return stats
      ?   <Container text>
          <br/>
            <Divider color='green'>
              <br />
              <br />
              <div class="ui green two statistics">
              <div class="statistic">
                  <div class="value">
                    <i class="money bill outline icon"></i>R{stats[8]}
                  </div>
                  <div class="label">
                    Revenue
                  </div>
                </div>
                <div class="statistic">
                  <div class="value">
                  <i class="money bill outline icon"></i> R{stats[9]}
                  </div>
                  <div class="label">
                    Revenue today
                  </div>
                </div>
                <div class="statistic">
                  <div class="value">
                  <i class="user plus icon"></i>{stats[0]}
                  </div>
                  <div class="label">
                    Signups
                  </div>
                </div>
                <div class="statistic">
                  <div class="value">
                  <i class="user plus icon"></i>{stats[1]}
                  </div>
                  <div class="label">
                    Signups today
                  </div>
                </div>
                <div class="statistic">
                  <div class="value">
                    <i class="shopping basket icon"></i>{stats[2]}
                  </div>
                  <div class="label">
                    Orders
                  </div>
                </div>
                <div class="statistic">
                  <div class="value">
                    <i class="shopping basket icon"></i>{stats[3]}
                  </div>
                  <div class="label">
                    Orders today
                  </div>
                </div>
                <div class="statistic">
                  <div class="value">
                    <i class="credit card icon"></i>{stats[4]}
                  </div>
                  <div class="label">
                    Subscriptions
                  </div>
                </div>
                <div class="statistic">
                  <div class="value">
                    <i class="credit card icon"></i>{stats[5]}
                  </div>
                  <div class="label">
                    Subscriptions today
                  </div>
                </div>
                <div class="statistic">
                  <div class="value">
                    <i class="plane icon"></i>{stats[6]}
                  </div>
                  <div class="label">
                    Trips
                  </div>
                </div>
                <div class="statistic">
                  <div class="value">
                  <i class="car icon"></i> {stats[7]}
                  </div>
                  <div class="label">
                    Vehicles
                  </div>
                </div>
              </div>
              <br />
              <br />
              <Header as='h2' icon textAlign='center' color='green'>Revenue per month</Header>
              <LineChart download="Revenue per month"  data={stats[10]} />
              <Header as='h2' icon textAlign='center' color='green'>Users per month</Header>
              <LineChart download="Users per month"  data={stats[11]} />
              <Header as='h2' icon textAlign='center' color='green'>Trips per month</Header>
              <LineChart download="Trips per month"  data={stats[12]} />
              <Header as='h2' icon textAlign='center' color='green'>Orders per month</Header>
              <LineChart download="Orders per month"  data={stats[13]} />
            </Divider>
          </Container>
      : <Container text>
        <Dimmer active inverted>
          <Loader content='Loading' />
        </Dimmer>
      </Container>
  }
}

export default Dashboard
